import React, { useState } from 'react'
import { Box, Flex, Image as ImageComponent, Text } from '@chakra-ui/react';
import { AboutCard } from '../../components/AboutUs/aboutCard';
import { PerformanceBanner, RatingBanner, UploadListingBanner } from '../../components/Banner';
import { PrimaryButton } from '../../components/button';
import { TrustedCompanies } from '../../components/Landing';
import { otherListingProperties, otherListingPropertiesTools, professionalFaq } from '../../data';
import { WrapperStyle } from '../../styles/newDesignStyles';
import { HeaderText, RealtorsHeader, RealtorsSemiHeader, SemiHeaderText } from '../../styles/typography';
import { AuthModal } from '../../components/Auth/withAuthModal';
import { useAuth } from '../../utils/auth/newAuth';
import Head from 'next/head';
import { BreadCrumb } from '../../components/AppHeader/BreadCrumb';
import router from 'next/router';

const BusinessBrokers = () => {
    const [isAuthBoxOpen, setisAuthBoxOpen] = useState(false);
    const { user } = useAuth();

    return (
        <>

            <Head>
                <title key="title">Business Brokers - Find and Share Business Listings</title>
                <meta key="description" name="description" content="List, buy and prospect leads for all your listings on Zonado, a platform 100% dedicated to businesses and commercial real estate. Sign up and get started for free." />
                <meta key="og:title" property="og:title" content='Business Brokers - Business and Commercial Real Estate Listings' />
                <meta key="og:description" property="og:description" content="List, buy and prospect leads for all your listings on Zonado, a platform 100% dedicated to businesses and commercial real estate. Sign up and get started for free." />

                <link key="fav1" rel="apple-touch-icon" sizes="180x180" href="/favicons/apple-touch-icon.png" />
                <link key="fav2" rel="icon" type="image/png" sizes="32x32" href="/favicons/favicon-32x32.png" />
                <link key="fav3" rel="icon" type="image/png" sizes="16x16" href="/favicons/favicon-16x16.png" />
                <link key="fav5" rel="mask-icon" href="/favicons/safari-pinned-tab.svg" color="#5bbad5" />
                <link key="fav6" rel="shortcut icon" href="/favicons/favicon.ico" />
                <link rel="canonical" href="https://zonado.com/who-we-help/business-broker" />
                <meta key="msFav" name="msapplication-TileColor" content="#2d89ef" />
                <meta name="msapplication-config" content="favicons/browserconfig.xml" />
                <meta name="theme-color" content="#ffffff" />

            </Head>

            <AuthModal
                createListing={true}
                onClose={() => setisAuthBoxOpen(false)}
                isOpen={isAuthBoxOpen}

            />

            <WrapperStyle>

                {/* breadcrumb */}
                <BreadCrumb to={"Business brokers"} />

                <Flex flexDir={{ base: "column", md: "row" }} mt={{ md: "0", lg: "50px" }} justifyContent={"space-between"} alignItems={"center"}>
                    <Flex
                        // px={{ md: "0", lg: "50px" }}
                        pt={{ base: "68px", md: "33px", lg: "26px" }}
                        pb={{ base: "0", lg: "26px" }}
                        flexDir={"column"} w={{ md: "40%", lg: "49%" }}
                    >
                        <HeaderText text={"Power your workflow"} />
                        <SemiHeaderText
                            text={"Zonado was built to escape the frustrations shared by Canadian business Brokers. Broken transacting process, unauthentic listings, fragmented flow is history with Zonado."}
                        />

                        <PrimaryButton
                            mb={"36px"} label={"Add a Free Listing"}
                            mr={"auto"} mt={"43px"}
                            onClick={() => user ? router.push("/add-listing") : setisAuthBoxOpen(true)}
                        />

                    </Flex>

                    <Box w={{ md: "50%" }} py={"14px"} pr={"11px"}>
                        <ImageComponent src={"/images/newLanding/businessBrokerBanner.svg"} h={"100%"} objectFit={"contain"} w={["100%", "350px", "100%"]} mx={"auto"} />
                    </Box>
                </Flex>

                <Flex flexDir={"column"} mt={"50px"} >
                    <Text color={"gray.500"} fontSize={"16px"}>Trusted by</Text>

                    <Flex flexDir={"row"} mt={"23px"} className={"trustedCompanies"}>
                        <TrustedCompanies img={"/images/newLanding/trustedCompanies/image_2.svg"} />
                        <TrustedCompanies img={"/images/newLanding/trustedCompanies/image 4.svg"} />
                        <TrustedCompanies img={"/images/newLanding/trustedCompanies/Vector.svg"} />
                        <TrustedCompanies img={"/images/newLanding/trustedCompanies/image 30.svg"} />
                        <TrustedCompanies className={"remove"} img={"/images/newLanding/trustedCompanies/image 7.svg"} />
                        <TrustedCompanies className={"remove"} img={"/images/newLanding/trustedCompanies/image 3.svg"} />
                        <TrustedCompanies className={"remove"} img={"/images/newLanding/trustedCompanies/image 6.svg"} />
                        <TrustedCompanies className={"remove"} img={"/images/newLanding/trustedCompanies/image 22.svg"} />
                        <TrustedCompanies className={"remove"} img={"/images/newLanding/trustedCompanies/image 5.svg"} />
                        <TrustedCompanies className={"remove"} img={"/images/newLanding/trustedCompanies/image 8.svg"} />
                    </Flex>
                </Flex>

                <Box mt={"96px"}>
                    <RealtorsHeader
                        text={"All your buying, selling and lead prospecting on 1 platform"}
                    />
                    <RealtorsSemiHeader text={"Industry platforms limit Brokers from sharing their listings, leaving them restricted and limited in reach. Zonado connects buyers, private investors, Realtors with Business Brokers across the nation."}
                    />

                    <Flex mt={"56px"} flexDir={"row"} flexWrap={"wrap"} justifyContent={"space-between"}>
                        {
                            otherListingProperties.map(({ id, ...rest }) =>
                                <AboutCard
                                    key={id}
                                    item={rest}
                                />
                            )
                        }
                    </Flex>
                </Box>

                {/* performance banner */}
                <PerformanceBanner />

                {/* broker tools  */}
                <Box>
                    <RealtorsHeader text={"A powerful suite of Broker Tools"} />
                    <RealtorsSemiHeader text={"Zonado was built as a result of intensive user interviews with Business Brokers from across Canada. The result is a suite of elegant solutions to power your workflow"} />

                    <Flex mt={"56px"} flexDir={"row"} flexWrap={"wrap"} justifyContent={"space-between"}>
                        {
                            otherListingPropertiesTools.map(({ id, ...rest }) =>
                                <AboutCard
                                    key={id}
                                    item={rest}
                                />
                            )
                        }
                    </Flex>
                </Box>

                {/* upload listing banner */}
                <UploadListingBanner
                    bannerBody={<>Upload a flyer/listing details & photos and we will put up your listing for you in less than 24 hours, <strong>free</strong>.</>}
                    bannerHeader={"Let us upload your listing for you"}
                    bannerImage={"/images/newLanding/businessBrokerUploadListing.png"}
                />

                {/* ratings banner */}
                <RatingBanner
                    ratingImg={"/images/newLanding/businessBrokerTestimony.png"}
                    ratingHeader={'Awesome service'}
                    review={<>I spoke to the team at Zonado to post my business for sale, they helped me by creating  great content, great service,
                        <br />Absolutely the best at what they do</>}
                    reviewer={"- Barberholic Barber (Ottawa)"}
                />

            </WrapperStyle>
        </>
    )
}

export default BusinessBrokers

BusinessBrokers.isProfessional = true;
BusinessBrokers.faq = professionalFaq;